import { requiredMessage } from 'validation'
import * as yup from 'yup'

export const registerAppSchema = yup.object().shape({
  note: yup.string().trim().required(requiredMessage),
})
